import state from '@/vuex/tramitacoes/state.js'
import getters from '@/vuex/tramitacoes/getters.js'
import mutations from '@/vuex/tramitacoes/mutations.js'
import actions from '@/vuex/tramitacoes/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
